import { useSyncExternalStore } from 'react';
import { Camera } from './camera.ts';
import { CELL } from './geometry.ts';

/** Largest zoom: one cell this many CSS px. */
export const MAX_CELL_PX = 192;

/** The board's camera. The isometric labels follow the map's edges, so no screen bands. */
export function createBoardCamera(): Camera {
  return new Camera({ maxZoom: MAX_CELL_PX / CELL });
}

/** Current size of one cell in CSS px, for readouts. */
export function useCellPx(camera: Camera): number {
  return useSyncExternalStore(camera.subscribe, () => CELL * camera.getSnapshot().zoom);
}
